import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { marker as _ } from "@biesbjerg/ngx-translate-extract-marker";
import {
  DataService,
  NotificationService,
  Dialog,
  LanguageCode,
} from "@bb-vendure/admin-ui/core";

import { SharedModule } from "@bb-vendure/admin-ui/core";
import { CreateDefaultProductDescriptionTranslationDocument } from "src/generated-gql/graphql";
import { RichTextEditorComponent } from "../detail/rich-text-editor/rich-text-editor.component";

@Component({
  standalone: true,
  imports: [SharedModule, RichTextEditorComponent],
  templateUrl: "dialog.component.html",
})
export class DefaultProductDescriptionTranslationDialogComponent
  implements OnInit, Dialog
{
  detailForm = this.formBuilder.group({
    title: ["", Validators.required],
    languageCode: ["", Validators.required],
    topDescription: [""],
    bottomDescription: [""],
  });
  languageCodes = Object.values(LanguageCode);

  public readonly updatePermissions = ["UpdateDefaultProductDescription"];
  params = {
    entity: "Translation",
  };

  constructor(
    private formBuilder: FormBuilder,
    private notificationService: NotificationService,
    protected dataService: DataService
  ) {}
  resolveWith: (result?: any) => void;

  ngOnInit() {}

  ngOnDestroy() {}

  create() {
    const form = this.detailForm;
    if (!form.dirty) {
      return;
    }
    this.resolveWith(form.value);
  }
}
